<template>
  <span>{{ value }}</span>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatReadOnlyAttributeValue",
  props: {
    id: {
      type: [String, Number]
    },
    attribute: [String],
    value: [String]
  }
});
</script>
